import './PasswordChange.scss';
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setIsLoggedIn, setIsAdmin, setUserInfo } from '../../reduxToolkit/redux';
import fnc from '../mymod/commFunction';

function PasswordChange() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.appReducer.userInfo);

  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!currentPw || !newPw || !confirmPw) {
      alert('모든 항목을 입력해주세요.');
      return;
    }
    if (newPw !== confirmPw) {
      alert('새 비밀번호가 일치하지 않습니다.');
      return;
    }
    if (newPw.length < 6) {
      alert('비밀번호는 6자 이상이어야 합니다.');
      return;
    }

    fnc.sendAxios('/accountRoutes/updatePassword', {
      id: userInfo.userId,
      currentPw,
      newPw,
    }, (res) => {
      if (res.error) {
        alert(res.message || '비밀번호 변경에 실패했습니다.');
        return;
      }
      alert('비밀번호가 변경되었습니다.\n보안을 위해 다시 로그인해주세요.');
      dispatch(setIsLoggedIn(false));
      dispatch(setIsAdmin(false));
      dispatch(setUserInfo({}));
      navigate('/login');
    });
  };

  return (
    <div className='PasswordChange'>
      <form onSubmit={handleSubmit}>
        <p className='section-title'>비밀번호 변경</p>

        <div>
          <label>*현재 비밀번호</label>
          <input
            type='password'
            value={currentPw}
            onChange={(e) => setCurrentPw(e.target.value)}
            placeholder='현재 비밀번호'
          />
        </div>

        <div>
          <label>*새 비밀번호</label>
          <input
            type='password'
            value={newPw}
            onChange={(e) => setNewPw(e.target.value)}
            placeholder='새 비밀번호 (6자 이상)'
          />
        </div>

        <div>
          <label>*새 비밀번호 확인</label>
          <input
            type='password'
            value={confirmPw}
            onChange={(e) => setConfirmPw(e.target.value)}
            placeholder='새 비밀번호 확인'
          />
        </div>

        <Button variant='contained' className='btn-submit' type='submit'>
          변경 완료
        </Button>
      </form>
    </div>
  );
}

export default PasswordChange;
